import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=557218a3&"
import script from "./Icon.vue?vue&type=script&lang=js&"
export * from "./Icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('557218a3')) {
      api.createRecord('557218a3', component.options)
    } else {
      api.reload('557218a3', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=557218a3&", function () {
      api.rerender('557218a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Icon.vue"
export default component.exports